import { ERROR_NAMES } from '../constants.js'

const options = {
  abortEarly: false, // include all errors
  stripUnknown: false // remove unknown props
}

export const validate = async (schema, values) => {
  try {
    return await schema.validate(values, options)
  } catch (e) {
    e.name = ERROR_NAMES.YUP_VALIDATION
    throw e
  }
}
